import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ScriptLoader, WindowRef } from '@spartacus/core';
import { QualtricsLoaderService } from '@spartacus/qualtrics/components';
import { map } from 'rxjs/operators';
import { BaseSiteConfigService } from '../base-site/base-site-config.service';

@Injectable({
  providedIn: 'root',
})
export class QualtricsService extends QualtricsLoaderService {
  constructor(
    winRef: WindowRef,
    @Inject(PLATFORM_ID) platformId: Object,
    scriptLoader: ScriptLoader,
    private baseSiteConfigService: BaseSiteConfigService
  ) {
    super(winRef, platformId, scriptLoader);
  }

  getQualtrics() {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.qualtrics.project.id', 'shimano.qualtrics.environment'])
      .pipe(map((configs) => configs));
  }
}
